import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Distinct storage key from the tenant admin app's 'authToken' — these are
// two different JWTs (no tenant_id vs. tenant-bound) and must never be
// confused with each other, even if both apps are ever open in the same
// browser.
const addAuthToken = (config) => {
  const token = localStorage.getItem('platformAuthToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

const handleResponseError = (error) => {
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('platformAuthToken');
    localStorage.removeItem('platformUserData');
    if (window.location.pathname !== '/login') {
      window.location.href = '/login?session=expired';
    }
  }
  return Promise.reject(error);
};

axiosInstance.interceptors.request.use(addAuthToken, (error) => Promise.reject(error));
axiosInstance.interceptors.response.use((response) => response, handleResponseError);

export default axiosInstance;
